import { render } from "./LicensedPageExpiryReport.vue?vue&type=template&id=4be1725b&scoped=true"
import script from "./LicensedPageExpiryReport.vue?vue&type=script&lang=js"
export * from "./LicensedPageExpiryReport.vue?vue&type=script&lang=js"

import "./LicensedPageExpiryReport.vue?vue&type=style&index=0&id=4be1725b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be1725b"]])

export default __exports__